import { useContext, type ComponentProps } from 'react';
import { ThemeContext } from 'styled-components';
import MarkerIcon from './MarkerIcon';

/** Marker glyph for a call that has both a primary and a secondary location. */
export default function AssociatedMarkerIcon(
  props: ComponentProps<typeof MarkerIcon>,
) {
  const theme = useContext(ThemeContext);
  return <MarkerIcon {...props} color={theme?.colors?.lightWarning} />;
}
